
import './About.css';
import OverlayBackground from '../assets/images/our-features.png';


const About = () => (
  <section
    id="about"
    className="about sophisticated-about-bg"
    style={{
      backgroundImage: `url(${OverlayBackground})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'relative',
      zIndex: 1,
    }}
  >
    <div className="about-overlay" style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(247, 248, 253, 0.4)',
      zIndex: 1,
      pointerEvents: 'none',
    }}></div>
    <div style={{ position: 'relative', zIndex: 2, maxWidth: 1100, margin: '0 auto', padding: '4rem 1.5rem' }}>
      <h2 className="about-title" style={{ textAlign: 'center', fontSize: '2.3rem', color: '#2E3387', marginBottom: '2.5rem', letterSpacing: '0.01em', fontWeight: 800 }}>About Us</h2>
      <div className="about-content">
        <div className="about-text">
          <p><strong>Seder Travel & Tourism</strong> is inspired by the buckthorn tree—its branches reaching far and wide, just like our journeys that connect you to the world. We believe every trip should be seamless, inspiring, and unforgettable.</p>
          <p>With over four decades of expertise, our passionate team of travel architects, multilingual guides, and logistics pros crafts journeys that go beyond the ordinary. Whether you’re an adventurer, a business traveler, or a family explorer, we tailor every detail to your dreams.</p>
          <p>Our award-winning service is powered by cutting-edge digital tools, a global partner network, and a relentless commitment to quality. From effortless booking to 24/7 support, we make every moment of your journey smooth, secure, and truly memorable.</p>
        </div>
        <div className="stats">
          <div className="stat-item">
            <h3>43+</h3>
            <p>Years of Excellence</p>
          </div>
          <div className="stat-item">
            <h3>500+</h3>
            <p>Delighted Clients</p>
          </div>
          <div className="stat-item">
            <h3>57+</h3>
            <p>Global Destinations</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;
